function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShielding = function SvgShielding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-142.2 -49.2 126.7 138",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 11,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M-22-14.9     c-38-13.3-56.8-27.8-56.8-27.8s-18.8,14.6-56.8,27.8c0,0-1.6,36.3,15.1,60.9c16.6,24.5,41.8,36.3,41.8,36.3s25.1-11.9,41.7-36.4     C-20.4,21.4-22-14.9-22-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 11,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M-117.7-4     c0,0-1.1,24.9,10.4,41.8s28.6,24.9,28.6,24.9V-8.1v-15C-78.8-23.1-91.7-13.1-117.7-4z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShielding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shielding.00c4e764.svg";
export { ForwardRef as ReactComponent };